import { Box, BoxProps, Breakpoint, Container } from '@mui/material';
import { ForwardedRef, ReactNode, UIEventHandler, forwardRef } from 'react';

type SimplePageLayoutProps = {
  children: ReactNode;
  maxWidth?: false | Breakpoint;
  disableGutters?: boolean;
  onScroll?: UIEventHandler<HTMLDivElement>;
  bgcolor?: BoxProps['bgcolor'];
  containerSx?: BoxProps['sx'];
};

export const SIMPLE_PAGE_LAYOUT_ID = 'simple-page-layout';

export const SimplePageLayout = forwardRef(
  (
    props: SimplePageLayoutProps,
    ref: ForwardedRef<Element | undefined>,
  ): JSX.Element => {
    const {
      children,
      maxWidth = 'sm',
      disableGutters,
      onScroll,
      bgcolor = 'background.default',
      containerSx = {},
    } = props;

    return (
      <Box
        sx={{
          width: '100%',
          overflowY: 'auto',
          pt: 3,
          pb: 'max(env(safe-area-inset-bottom), 24px)',
          bgcolor,
          ...containerSx,
        }}
        ref={ref}
        onScroll={onScroll}
        id={SIMPLE_PAGE_LAYOUT_ID}
      >
        <Container
          maxWidth={maxWidth}
          sx={{ minHeight: '100%', display: 'flex', flexDirection: 'column' }}
          disableGutters={disableGutters}
        >
          {children}
        </Container>
      </Box>
    );
  },
);

SimplePageLayout.displayName = 'SimplePageLayout';
